import React, { Component } from "react";
import PropTypes from "prop-types";
import { showNotification as showNotificationAction, translate } from "admin-on-rest";
import { push as pushAction } from "react-router-redux";
import { connect } from "react-redux";
import "./ContactForm.css";

const request = require("superagent");
const Config = require("../config");
var email, category, description;

class PassForm extends Component {
  constructor(props) {
    super(props);
    this.state = { pass_1: "", pass_2: "" };
    this.handleChange_2 = this.handleChange_2.bind(this);
    this.handleChange_1 = this.handleChange_1.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange_2(event) {
    this.setState({ pass_1: event.target.value });
  }

  handleChange_1(event) {
    this.setState({ pass_2: event.target.value });
  }

  handleSubmit(event) {
    //alert('A name was submitted: ' + this.state.value);
    event.preventDefault();

    var pass_f = this.state.pass_1;
    var pass_s = this.state.pass_2;
    var auth_token = localStorage.getItem("auth_token");
    var email = localStorage.getItem("email");

    console.log("pass_f", pass_f);
    console.log("pass_s", pass_s);
    console.log("auth_token", auth_token);
    console.log("email", email);

    if (pass_f == pass_s) {
      request
        .post(Config.serverUrl + "/api/change_password_admin")
        .send({ password: pass_f, email: email, token: auth_token })
        .set("Accept", "application/json")
        .then(function(res) {
          alert("Ο κωδικός έχει αλλάξει.");
          console.log("success");
        })
        .catch(e => {
          alert("Κάτι πηγε στραβά.");
          console.error(e);
        });
    } else {
      alert("Οι κωδικοι δεν ταιριαζουν");
    }
  }

  render() {
    const { translate } = this.props;
    return (
      <form className="contact-form" onSubmit={this.handleSubmit}>
        <div className="form-field">
          <label htmlFor="message">
            <div className="big_title">
              {" "}
              {translate("resources.change_pass.name")}{" "}
            </div>
            <div className="label-content">
              {" "}
              {translate("resources.new_pass.name")}
            </div>
            <input
              className="bigger_input"
              type="text"
              onChange={this.handleChange_1}
              name="password_1"
            />
            <div className="label-content">
              {" "}
              {translate("resources.repeat_pass.name")}{" "}
            </div>
            <input
              className="bigger_input"
              type="text"
              onChange={this.handleChange_2}
              name="password_2"
            />
          </label>
        </div>

        <button type="submit" className="button_sub">
          {translate("resources.save.name")}
        </button>
      </form>
    );
  }
}

PassForm.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func
};

const mapStateToProps = (state) => {
  return {
    showNotification: showNotificationAction,
    push: pushAction
  };
};

export default translate(connect(null, mapStateToProps)(PassForm));



// WEBPACK FOOTER //
// ./src/custom/change_pass.js